module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0018.4aba45b6.jpg";